export default "__VITE_ASSET__DWWebpY7__"